import React, { useState, useRef, useEffect } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import './AccountMenu.scss';

const AccountMenu = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/login');
    } catch (error) {
      console.error('Logout failed:', error);
    }
  };

  return (
    <div className="account-menu" ref={dropdownRef}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center space-x-2 text-text-primary hover:text-primary transition duration-150"
      >
        <div className="w-8 h-8 rounded-full bg-primary-transparent flex items-center justify-center">
          <span className="text-primary font-semibold">
            {user?.email?.[0]?.toUpperCase() || 'U'}
          </span>
        </div>
        <span className="hidden md:block">{user?.email}</span>
      </button>

      {isOpen && (
        <div className="account-menu-dropdown">
          <div className="py-1" role="menu">
            <button
              onClick={() => {
                navigate('/subscription');
                setIsOpen(false);
              }}
              className="dropdown-item"
              role="menuitem"
            >
              Subscription
            </button>
            <button
              onClick={() => {
                navigate('/account/settings');
                setIsOpen(false);
              }}
              className="dropdown-item"
              role="menuitem"
            >
              Settings
            </button>
            <button
              onClick={handleLogout}
              className="dropdown-item danger"
              role="menuitem"
            >
              Sign out
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default AccountMenu; 